import { types } from "../../types/types";
import { fetchConToken } from "../../helpers/fetch";
import { startAlerta } from "../ui/alertas";

export const bandejasAutorizacionTraerStart = () => ({ type: types.bandejasAutorizacionTraerStart });
export const bandejasAutorizacionLimpiar = () => ({ type: types.bandejasAutorizacionLimpiar });
export const bandejasAutorizacionTraerError = (error) => ({ type: types.bandejasAutorizacionTraerError,payload: error});
export const bandejasAutorizacionTraerSuccess = (payload) => {
    return {
        type: types.bandejasAutorizacionTraerSuccess,
        payload: payload
    }
}
export const bandejasAutorizacionUsuarioSeleccionado = (payload) => {
    return {
        type: types.bandejasUsuarioSeleccionado,
        payload: payload
    }
}
  
export const fetchBandejasAutorizacion = () => {
    return async (dispatch) => {
        dispatch(bandejasAutorizacionTraerStart());
        const response = await fetchConToken(`BandejasAutorizacion`);
        if (!response.ok) {
            dispatch(bandejasAutorizacionTraerError(response.statusText));
            throw Error(response.statusText);
        }
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
            const lista = await response.json();
            if (lista.length>0) {
                dispatch(bandejasAutorizacionTraerSuccess(lista));
            }
        }
    };
};

export const fetchBandejasAutorizacionUsuario = (idUsuario) => {
    return async (dispatch) => {
        dispatch(bandejasAutorizacionTraerStart());
        const response = await fetchConToken(`UsuarioBandejasAutorizacion/traerBandejasUsuario/${ idUsuario }`);
        if (!response.ok) {
            dispatch(bandejasAutorizacionTraerError(response.statusText));
            throw Error(response.statusText);
        }
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
            const lista = await response.json();
            
            dispatch( bandejasAutorizacionUsuarioSeleccionado(lista) );
        }
    };
};

export const setBandejaUsuario = (idUsuario, idNivel) => {
    return async (dispatch, getState) => {
        try{
            dispatch(bandejasAutorizacionTraerStart());
            const response = await fetchConToken(`UsuarioBandejasAutorizacion`, {idUsuario, idNivel},'POST');
            const contentType = response.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                const respuesta = await response.json();
                if (!response.ok) throw respuesta.errores;
                
                const state = getState();
                const { bandejasUsuarioSeleccionado: bandejasAutorizacionActuales } = state.bandejasAutorizacion;
                const nuevasBandejasAutorizacion = [ ...bandejasAutorizacionActuales, respuesta ];

                dispatch( bandejasAutorizacionUsuarioSeleccionado(nuevasBandejasAutorizacion) );
            }
        } catch (err) {
            console.log( err );
            dispatch(startAlerta(err, "warning", `¡Error!`));
        }
    }; 
};

export const eliminarBandejaUsuario = (idUserNivel) => {
    return async (dispatch, getState) => {
        dispatch(bandejasAutorizacionTraerStart());

        const response = await fetchConToken(`UsuarioBandejasAutorizacion`, {idUserNivel},'DELETE');
        if (!response.ok) {
            dispatch(bandejasAutorizacionTraerError(response.statusText));
            throw Error(response.statusText);
        }
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
            const state = getState();
            const { bandejasUsuarioSeleccionado: bandejasAutorizacionActuales } = state.bandejasAutorizacion;
            const nuevasBandejasAutorizacion = bandejasAutorizacionActuales.filter( s=> s.idUsuarioBandejaAut !== idUserNivel)

            dispatch( bandejasAutorizacionUsuarioSeleccionado(nuevasBandejasAutorizacion) );
        }
    };
};